/* eslint-disable @typescript-eslint/no-explicit-any */
import { assign } from 'lodash';
import { createReducer } from '../util';
import {
  TOGGLE_MOBILE_NAV_BAR,
  UPDATE_CURRENT_PAGE,
  UPDATE_DISPLAY_NAME,
  UPDATE_LOGIN_STATUS,
  UPDATE_MODAL_VISIBLE,
  UPDATE_USER_AGENT_DETAILS,
} from './action';
import { State } from './type';

const initialState = {
  deviceType: 'desktop',
  showMobileNavBar: false,
  islogin: false,
  loginEmail: '',
  accessToken: '',
  refreshToken: '',
  modalVisible: false,
  displayName: '',
  user: {},
  currentPage: '',
  isNextGenSupported: false,
};

export default createReducer(initialState, {
  [UPDATE_LOGIN_STATUS]: function (state: State, action: any): State {
    return assign({}, state, {
      islogin: !!action.payload,
      displayName: action.payload.displayName,
      loginEmail: action.payload.email,
      accessToken: action.payload.accessToken,
      refreshToken: action.payload.refreshToken,
      user: {
        userId: action.payload.userId,
        userName: action.payload.displayName,
      },
    });
  },
  [UPDATE_MODAL_VISIBLE]: function (state: State, action: any): State {
    return assign({}, state, { modalVisible: action.payload });
  },
  [UPDATE_DISPLAY_NAME]: function (state: State, action: any): State {
    return assign({}, state, { displayName: action.payload });
  },
  [TOGGLE_MOBILE_NAV_BAR]: function (state: State, action: any): State {
    return assign({}, state, { showMobileNavBar: action.payload });
  },
  [UPDATE_CURRENT_PAGE]: function (state: State, action: any): State {
    return assign({}, state, { currentPage: action.payload });
  },
  [UPDATE_USER_AGENT_DETAILS]: function (state: State, action: any): State {
    const { isNextGenSupported, deviceType } = action.payload;
    return assign({}, state, { isNextGenSupported, deviceType });
  },
});
